// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"ContractSavingsCollectionReminder_modal-content_1LSJR"};